import React from 'react';
import {
  FaTimes,
  FaUsers,
  FaTruck,
} from 'react-icons/fa';
import { Shift } from '../../shifts/services/ShiftService';
import { TeamAsset } from '../services/PlantafelService';
import styles from './PlantafelSidePanel.module.css';

interface SidePanelAttachmentsProps {
  shift: Shift | null;
  assignedAssets: TeamAsset[];
  removingEmployee: number | null;
  removingAsset: number | null;
  handleRemoveEmployee: (employeeId: number) => void;
  handleRemoveAsset: (assetId: number) => void;
}

export function SidePanelAttachments({
  shift, assignedAssets,
  removingEmployee, removingAsset,
  handleRemoveEmployee, handleRemoveAsset,
}: SidePanelAttachmentsProps): React.JSX.Element | null {
  if (!shift) return null;

  return (
    <>
      {/* Zugewiesene Mitarbeiter */}
      <div className={styles.section} style={{ marginBottom: '16px' }}>
        <div className={styles.sectionTitle}>
          <FaUsers size={11} style={{ marginRight: '6px' }} />
          Mitarbeiter ({shift.assigned_employees?.length || 0})
        </div>
        {(!shift.assigned_employees || shift.assigned_employees.length === 0) ? (
          <div className={styles.noAssignedText}>
            Keine Mitarbeiter zugewiesen
          </div>
        ) : (
          <div className={styles.assignedChipsRow}>
            {shift.assigned_employees.map((emp: any) => (
              <div key={emp.id} className={styles.employeeChip}>
                <span>{emp.first_name} {emp.last_name?.[0]}.</span>
                <button
                  onClick={() => handleRemoveEmployee(emp.id)}
                  disabled={removingEmployee === emp.id}
                  className={`${styles.removeChipButton} ${removingEmployee === emp.id ? styles.removeChipButtonDisabled : ''}`}
                  style={{ color: '#166534' }}
                  title="Entfernen"
                >
                  <FaTimes size={9} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Zugewiesene Assets */}
      <div className={styles.section} style={{ marginBottom: '16px' }}>
        <div className={styles.sectionTitle}>
          <FaTruck size={11} style={{ marginRight: '6px' }} />
          Assets ({assignedAssets.length})
        </div>
        {assignedAssets.length === 0 ? (
          <div className={styles.noAssignedText}>
            Keine Assets zugewiesen
          </div>
        ) : (
          <div className={styles.assignedChipsRow}>
            {assignedAssets.map((asset: any) => (
              <div key={asset.id} className={styles.assetChip}>
                <span>{asset.asset_name || asset.license_plate || `Asset ${asset.asset_id || asset.id}`}</span>
                <button
                  onClick={() => handleRemoveAsset(asset.asset_id || asset.id)}
                  disabled={removingAsset === (asset.asset_id || asset.id)}
                  className={`${styles.removeChipButton} ${removingAsset === (asset.asset_id || asset.id) ? styles.removeChipButtonDisabled : ''}`}
                  style={{ color: '#374151' }}
                  title="Entfernen"
                >
                  <FaTimes size={9} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
